const STORAGE_KEY = 'pendingCommunitySubscriptionSlots';

export type PendingCommunitySubscriptionSlots = {
  userId: string;
  activeCommunityIds: string[];
};

function readAll(): PendingCommunitySubscriptionSlots[] {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (item): item is PendingCommunitySubscriptionSlots =>
        typeof item === 'object' &&
        item !== null &&
        typeof (item as PendingCommunitySubscriptionSlots).userId ===
          'string' &&
        Array.isArray(
          (item as PendingCommunitySubscriptionSlots).activeCommunityIds,
        ),
    );
  } catch {
    return [];
  }
}

function writeAll(entries: PendingCommunitySubscriptionSlots[]) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
}

export function setPendingCommunitySubscriptionSlots(
  userId: string,
  activeCommunityIds: string[],
): void {
  const rest = readAll().filter((e) => e.userId !== userId);
  writeAll([...rest, { userId, activeCommunityIds }]);
}

export function getPendingCommunitySubscriptionSlots(
  userId: string,
): string[] | null {
  const entry = readAll().find((e) => e.userId === userId);
  return entry?.activeCommunityIds ?? null;
}

export function clearPendingCommunitySubscriptionSlots(userId: string): void {
  writeAll(readAll().filter((e) => e.userId !== userId));
}

export async function applyPendingCommunitySubscriptionSlots(
  userId: string,
  updateSlots: (
    userId: string,
    activeCommunityIds: string[],
  ) => Promise<unknown>,
): Promise<boolean> {
  const pending = getPendingCommunitySubscriptionSlots(userId);
  if (!pending?.length) return false;
  await updateSlots(userId, pending);
  clearPendingCommunitySubscriptionSlots(userId);
  return true;
}
